










































































import { Vue, Component } from "vue-property-decorator";
import Prism from "vue-prism-component";
import { required, url } from "vuelidate/lib/validators";
import { namespace } from "vuex-class";
import { WebhookItem } from "@/modules/webhooks/types";

const Webhooks = namespace("webhooks");
@Component({
  components: {
    prism: Prism,
  },
})
export default class DeleteWebhook extends Vue {
  @Webhooks.Action("deleteWebhook") deleteWebhook!: (
    webhookId: string
  ) => Promise<{}>;
  @Webhooks.Action("fetchCurrentWebhook") fetchCurrentWebhook!: (
    webhookId?: string
  ) => Promise<{}>;
  @Webhooks.Action("fetchWebhooks") fetchWebhooks!: () => Promise<{}>;

  @Webhooks.Getter("getCurrentWebhook") currentWebhook: WebhookItem;

  loading = false;
  hasErrors = false;
  async beforeMount() {
    const { webhookId } = this.$route.params;
    await this.fetchCurrentWebhook(webhookId);
  }
  goBack() {
    const { webhookId } = this.$route.params;
    this.$router.push({ name: "viewWebhook", params: { webhookId } });
  }
  confirmWebhookDelete() {
    this.loading = true;

    const { webhookId } = this.$route.params;
    this.deleteWebhook(webhookId)
      .then(() => {
        this.loading = false;
        this.$notify({
          group: "success",
          title: "Success",
          text: "Webhook deleted successfully.",
        });
        this.fetchWebhooks();
        this.goBack();
      })
      .catch(() => {
        this.$notify({
          group: "error",
          title: "Error",
          text: "Failed to delete webhook.",
        });
        this.loading = false;
      });
  }
  validations() {
    return {
      webhookForm: {
        endpoint: {
          required,
          url,
        },
        name: {
          required,
        },
      },
    };
  }
}
